import {
  formatName,
  STAFF_ROLE_LABELS,
  type TaskResponse,
  type TaskStatus,
} from '@snootsvet/shared'

import type { BadgeVariant } from '@/frontend/components/ui/badge'

/** Badge variant for each task status. */
export const TASK_STATUS_VARIANT = {
  open: 'info',
  in_progress: 'pending',
  completed: 'success',
  cancelled: 'neutral',
} as const satisfies Record<TaskStatus, BadgeVariant>

/** Awaiting Payment is amber, Ready is blue, Booked is green. */
const PROCEDURE_REQUEST_STATUS_VARIANT = {
  open: 'pending',
  in_progress: 'info',
  completed: 'success',
  cancelled: 'neutral',
} as const satisfies Record<TaskStatus, BadgeVariant>

/** Badge variant for a specific task — procedure requests colour their statuses differently. */
export function getTaskStatusVariant(task: Pick<TaskResponse, 'type' | 'status'>): BadgeVariant {
  return task.type === 'procedure_request'
    ? PROCEDURE_REQUEST_STATUS_VARIANT[task.status]
    : TASK_STATUS_VARIANT[task.status]
}

/** Renders the assignee display string for a task. */
export function formatAssignee(task: TaskResponse): string {
  if (task.assignee) {
    const name = formatName(task.assignee)
    if (name) return name
  }
  if (task.assigneeRole) {
    const roleLabel = STAFF_ROLE_LABELS[task.assigneeRole]
    if (task.assigneeClinic) return `${roleLabel} @ ${task.assigneeClinic.name}`
    return roleLabel
  }
  return '—'
}
